module.exports = require('./helpers/bundle-url').getBundleURL('6XdXW') + "logo.c51670a8.svg";